import React from 'react';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastMessage {
  message: string;
  type: 'success' | 'error';
  action?: ToastAction;
}

interface ToastProps {
  toast: ToastMessage | null;
  onDismiss: () => void;
}

export function Toast({ toast, onDismiss }: ToastProps) {
  if (!toast) return null;
  return (
    <div
      className={`toast toast-${toast.type}`}
      onClick={onDismiss}
      role="status"
      style={{ display: 'flex', alignItems: 'center', gap: 'var(--sp-3)' }}
    >
      <span style={{ flex: 1 }}>
        <span style={{ marginRight: 6 }}>{toast.type === 'error' ? '⚠' : '✓'}</span>
        {toast.message}
      </span>
      {toast.action && (
        <button
          className="btn btn-sm btn-ghost"
          onClick={(e) => {
            e.stopPropagation();
            toast.action!.onClick();
          }}
          style={{
            color: 'var(--accent)',
            fontWeight: 600,
            padding: '2px 10px',
            flexShrink: 0,
          }}
        >
          {toast.action.label}
        </button>
      )}
    </div>
  );
}
